<template>
  <div class="table-skeleton" :style="{ '--cols': String(columns) }">
    <div class="skeleton-header" v-if="showHeader">
      <div v-for="c in columns" :key="'h-' + c" class="skeleton-cell header"></div>
    </div>
    <div class="skeleton-body">
      <div v-for="r in rows" :key="'r-' + r" class="skeleton-row">
        <div v-for="c in columns" :key="'c-' + r + '-' + c" class="skeleton-cell"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableSkeleton',
  props: {
    rows: {
      type: Number,
      default: 8
    },
    columns: {
      type: Number,
      default: 6
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.table-skeleton {
  width: 100%;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.skeleton-header {
  display: grid;
  grid-template-columns: repeat(var(--cols), 1fr);
  gap: 8px;
  padding: 12px;
  background: #f8f9fa;
}

.skeleton-body {
  padding: 12px;
  display: grid;
  gap: 10px;
}

.skeleton-row {
  display: grid;
  grid-template-columns: repeat(var(--cols), 1fr);
  gap: 8px;
}

.skeleton-cell {
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e9ecef 25%, #dee2e6 50%, #e9ecef 75%);
  background-size: 200px 100%;
  animation: shimmer 1.5s ease-in-out infinite;
}

.skeleton-cell.header {
  height: 16px;
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

:host,
.table-skeleton,
.skeleton-header,
.skeleton-row {
  --cols: 6;
}

@media (prefers-color-scheme: dark) {
  .table-skeleton {
    background: rgba(255, 255, 255, 0.247);
    border-color: #6c757d;
  }
  .skeleton-cell {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.253) 25%, rgba(255, 255, 255, 0.397) 50%, rgba(255, 255, 255, 0.08) 75%);
  }
  .skeleton-header {
    background: #3a3f44;
  }
}
</style>
